import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgUpload = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M18.475 15.584c1.533 0 2.775 1.23 2.775 2.75 0 1.518-1.242 2.75-2.775 2.75H5.525c-1.533 0-2.775-1.232-2.775-2.75 0-1.52 1.242-2.75 2.775-2.75H7.77c1.116 0 1.586 1.375 2.807 1.375h2.846c1.221 0 1.691-1.375 2.807-1.375z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M15.5 8.28 12 2.915 8.5 8.28z"
      clipRule="evenodd"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M11.998 8.278v4.638"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgUpload);
export default ForwardRef;
